import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'atm-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.scss'],
})
export class DataComponent implements OnChanges {
  @Input() data!: any;
  htmlDatas: any[] = [];

  constructor() {}

  ngOnChanges(): void {
    this.htmlDatas = this.setDataLevel(this.data);
  }

  setDataLevel(data: any): { key: string; value: any }[] {
    const displayData = [];

    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] !== null) {
          if (this.isObject(data[key]) && data[key]) {
            const nextLevel = this.setDataLevel(data[key]);
            displayData.push({ key, value: nextLevel });
          } else {
            displayData.push({ key, value: data[key] });
          }
        }
      }
    }

    return displayData;
  }

  isObject(data: any): boolean {
    return typeof data === 'object' && data !== null;
  }

  isString(elem: any): boolean {
    return typeof elem === 'string';
  }
  elemType(elem: any): string {
    return typeof elem;
  }
}
